import { Button } from "antd";
import RoundEditIcon from "../../../../assets/icons/RoundEditIcon";

import { Link, useParams } from "react-router-dom";
import TitleBar from "../../../../components/common/TitleBar";
import Loader from "../../../../components/ui/Loader";
import { useGetSurveyTemplateDetailsQuery } from "../../../../features/organization/survey/surveyApi";
import useError from "../../../../hooks/useError";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import DetailsTemplateCheckbox from "./_components/DetailsTemplateCheckbox";
import DetailsTemplateDate from "./_components/DetailsTemplateDate";
import DetailsTemplateDropdown from "./_components/DetailsTemplateDropdown";
import DetailsTemplateFileUpload from "./_components/DetailsTemplateFileUpload";
import DetailsTemplateImage from "./_components/DetailsTemplateImage";
import DetailsTemplateLinerScale from "./_components/DetailsTemplateLinerScale";
import DetailsTemplateMultipleCheGrid from "./_components/DetailsTemplateMultipleCheGrid";
import DetailsTemplateMultipleCho from "./_components/DetailsTemplateMultipleCho";
import DetailsTemplateMultipleChoGrid from "./_components/DetailsTemplateMultipleChoGrid";
import DetailsTemplateParagraph from "./_components/DetailsTemplateParagraph";
import DetailsTemplateRating from "./_components/DetailsTemplateRating";
import DetailsTemplateShortAns from "./_components/DetailsTemplateShortAns";
import DetailsTemplateTime from "./_components/DetailsTemplateTime";
import DetailsTemplateTitle from "./_components/DetailsTemplateTitle";
import SheetIcon from "./_icons/SheetIcon";

export default function DetailsTemplate() {
  const backLink = "/organizations/survey/templates";
  const { id } = useParams();

  const { data, isLoading, isError, error } = useGetSurveyTemplateDetailsQuery(
    Number(id),
    {
      skip: !id,
    }
  );

  useError(isError, error, "Survey template details data fail");

  const SurveyData = data?.data?.surveyTemplate;

  return (
    <>
      <SidebarLayout title="Survey">
        <TitleBar title="Details" backLink={backLink}>
          <div className="flex justify-start items-center gap-5">
            <Link
              to={`/organizations/survey/templates/survey-data-details/${Number(
                id
              )}`}
            >
              <Button
                icon={<SheetIcon className="mt-1" />}
                className="px-3 py-1.5 rounded-md outline outline-1 outline-offset-[-1px] text-sm font-medium !text-fuchsia-600 outline-fuchsia-300 flex justify-center items-center gap-2"
              >
                Response Sheet
              </Button>
            </Link>

            <Link to={`/organizations/survey/templates/update/${Number(id)}`}>
              <Button
                icon={
                  <RoundEditIcon
                    className="!mt-1 w-4 h-4"
                    currentColor="#ffffff"
                  />
                }
                type="primary"
                className="sm-button !px-3 !pt-2"
              >
                Edit
              </Button>
            </Link>
          </div>
        </TitleBar>

        {isLoading ? (
          <Loader />
        ) : (
          <div>
            {SurveyData?.cover_image && (
              <DetailsTemplateImage SurveyData={SurveyData} />
            )}

            {SurveyData?.title && SurveyData?.description ? (
              <DetailsTemplateTitle SurveyData={SurveyData} />
            ) : (
              ""
            )}

            {SurveyData?.surveyQuestion?.map((data) => {
              switch (data?.question_type) {
                case "short_answer":
                  return <DetailsTemplateShortAns key={data?.id} data={data} />;
                case "paragraph":
                  return (
                    <DetailsTemplateParagraph key={data?.id} data={data} />
                  );
                case "multiple_choice":
                  return (
                    <DetailsTemplateMultipleCho key={data?.id} data={data} />
                  );
                case "checkboxes":
                  return <DetailsTemplateCheckbox key={data?.id} data={data} />;
                case "dropdown":
                  return <DetailsTemplateDropdown key={data?.id} data={data} />;
                case "file_upload":
                  return (
                    <DetailsTemplateFileUpload key={data?.id} data={data} />
                  );
                case "linear_scale":
                  return (
                    <DetailsTemplateLinerScale data={data} key={data?.id} />
                  );
                case "rating":
                  return <DetailsTemplateRating data={data} key={data?.id} />;
                case "multiple_choice_grid":
                  return (
                    <DetailsTemplateMultipleChoGrid
                      data={data}
                      key={data?.id}
                    />
                  );
                case "checkbox_grid":
                  return (
                    <DetailsTemplateMultipleCheGrid
                      data={data}
                      key={data?.id}
                    />
                  );
                case "date":
                  return <DetailsTemplateDate data={data} key={data?.id} />;
                case "time":
                  return <DetailsTemplateTime data={data} key={data?.id} />;
                default:
                  return null;
              }
            })}

            {/* <DetailsTemplateLinerScale />

            <DetailsTemplateRating />

            <DetailsTemplateMultipleChoGrid />

            <DetailsTemplateMultipleCheGrid />

            <DetailsTemplateDate />

            <DetailsTemplateTime /> */}
          </div>
        )}
      </SidebarLayout>
    </>
  );
}
